// 申请单api

import { axiosPost } from "@/utils/request";

/**
 * 新增申请单
 * @param {*} data
 * @returns
 */
export const addApplicationForm = (data) => {
  return axiosPost({
    url: "/applicationForm/insertApplicationForm",
    data: data,
    tips: true,
  });
};

/**
 * 更新申请单
 * @param {*} data
 * @returns
 */
export const updateApplicationForm = (data) => {
  return axiosPost({
    url: "/applicationForm/updateApplicationForm",
    data: data,
    tips: true,
  });
};

/**
 * 删除申请单
 * @param {*} applicationFormId
 * @returns
 */
export const deleteApplicationForm = (applicationFormId) => {
  return axiosPost({
    url: "/applicationForm/delteApplicationFormById",
    data: {
      applicationFormId,
    },
    tips: true,
  });
};

/**
 * 审批申请单
 * @param {*} applicationFormId
 * @returns
 */
export const approvalApplicationForm = (applicationFormId) => {
  return axiosPost({
    url: "/applicationForm/approvalApplicationForm",
    data: {
      applicationFormId,
    },
  });
};

/**
 * 驳回申请单
 * @param {*} applicationFormId 申请单id
 * @param {*} rejectRemarks 驳回理由
 * @returns
 */
export const rejectApplicationForm = (applicationFormId, rejectRemarks) => {
  return axiosPost({
    url: "/applicationForm/rejectApplicationForm",
    data: { applicationFormId, rejectRemarks },
  });
};

/**
 * 查询申请单
 * @param {*} data
 * @returns
 */
export const listApplicationForm = (data) => {
  return axiosPost({
    url: "/applicationForm/selectApplicationForm",
    data: data,
  });
};
